export default __webpack_public_path__ + "static/appstore-be3d33797cfc8817610b02dc3288e149.png";